export enum StorageKeys {
  AccessToken = "@AccessToken",
  UserId = "@UserId",
  ResetPasswordLinkId = "@ResetPasswordLinkId",
}
